/* eslint-disable no-unused-vars */
import apiClient from "@/config/api";
const RESOURCE = "/properties";



const actions = {
    getImovel({ commit }, page) {
        const config = {
            'headers': {
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`
            }
        }
        console.log(config)
        return new Promise((resolve, reject) => {
            
            apiClient.get(`${RESOURCE}?page=${page}`, config)
                .then(res => {
                    commit("SET_IMOVEIS", res.data.data);
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
           
        })
    },
    getAllImovel({ commit }, page) {
        const config = {
            'headers': {
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`
            }
        }
        console.log(config)
        return new Promise((resolve, reject) => {
            
            apiClient.get(`${RESOURCE}/all?page=${page}`, config)
                .then(res => {
                    commit("SET_IMOVEIS", res.data.data);
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
           
        })
    },
    getImovelOptions({ commit }) {
        const config = {
            'headers': {
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`
            }
        }

        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/options`, config)
                .then(res => {
                    commit("SET_IMOVEIS_OPTIONS", res.data.data);
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
        })
    },
    // eslint-disable-next-line no-unused-vars
    getImovelBySlug({ commit }, slug) {
        const config = {
            'headers': {
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`
            }
        }

        return new Promise((resolve, reject) => {
            apiClient.get(`${RESOURCE}/slug/${slug}`, config)
                .then(res => {
                    // commit();
                    resolve(res.data.data)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
        })
    },
    storeImovel({ commit}, imovelData) {
        const config = {
            'headers': {
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`
            }
        }

        return new Promise((resolve, reject) => {
            apiClient.post(RESOURCE, imovelData, config)
                .then (res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                    console.error("API Error:", err);
                })
        })
    },
    destroy({ commit }, slug) {
        const config = {
            'headers': {
                'Authorization': `Bearer ${sessionStorage.getItem("token")}`
            }
        }
        return new Promise((resolve, reject) => {
            apiClient.delete(`${RESOURCE}/slug/${slug}`, config)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}
export default actions;